(() => {
  const initialize = container => {
    const roots = container.matches?.('[data-gfe-membership-v2]')
      ? [container]
      : container.querySelectorAll('[data-gfe-membership-v2]');
    roots.forEach(root => {
      if (root.dataset.membershipReady === 'true') return;
      root.dataset.membershipReady = 'true';
      root.querySelectorAll('[data-open-faq]').forEach(link => {
        link.addEventListener('click', event => {
          const detail = root.querySelector('#' + CSS.escape(link.dataset.openFaq));
          if (!detail) return;
          event.preventDefault();
          detail.open = true;
          detail.querySelector('summary').focus({ preventScroll: true });
          history.replaceState(null, '', link.hash);
          detail.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      });
      root.querySelectorAll('.tutorial').forEach(detail => {
        detail.addEventListener('toggle', () => {
          const frame = detail.querySelector('iframe');
          if (!frame) return;
          if (detail.open && !frame.hasAttribute('src')) frame.src = frame.dataset.src;
          if (!detail.open) frame.removeAttribute('src');
        });
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
